import { useState, useEffect } from 'react';
import {seisleveljp} from "./seislevel"
import styles from './css/healthalertpanel.module.css'

export default function Healthalertpanel(props) {
    const [seis, setseis] = useState("-");
    const [evalue, setEvalue] = useState("-");
    const [isolator, setIsolator] = useState("-");

    useEffect(() => {
        if (props.event && props.event.values && props.event.values.length > 0) {
            setseis(seisleveljp(props.event.values[0].seis));
        }
        if (props.event && props.event.damage) {
            var val = 0;
            var isolator = -1;
            for ( var adamage of props.event.damage ) {
                if (adamage.body_x != undefined && adamage.body_y != undefined)
                    val = Math.max(val,adamage.body_x.value,adamage.body_y.value)
                if (adamage.seisisolator != undefined)
                    isolator = Math.max(isolator,adamage.seisisolator.value)
            }
            if (val >= 1.0) {
                setEvalue("危険(退避)");
            } else if (val >= 0.5) {
                setEvalue("要注意(状況確認)")
            } else {
                setEvalue("安全(待機)")
            }
            if (isolator >= 1.0) {
                setIsolator("限界変位超過");
            } else if (isolator >= 0) {
                setIsolator("安全")
            } else {
                setIsolator("-")
            }
        }
    }, [props.event]);

    return (
        <div className={styles.contents}>
            <div className={styles.item}><div className={styles.title}>震度</div><div className={styles.value}>{seis}</div></div>
            <div className={styles.item}><div className={styles.title}>判定</div><div className={styles.value}>{evalue}</div></div>
            {
                (isolator != "-") ?
                    <div className={styles.item}><div className={styles.title}>免震</div><div className={styles.value}>{isolator}</div></div>
                :   <></>
            }
        </div>
    );
}